import { Alert, Avatar, Button, Icons } from '@commenda/kakashi';

interface Assignee {
  id: string;
  name: string;
  email: string;
}

interface ManageAssigneesStepProps {
  assignees: Assignee[];
  onAddAssignees: () => void;
  onRemoveAssignee: (assignee: Assignee) => void;
}

export const ManageAssigneesStep = ({
  assignees,
  onAddAssignees,
  onRemoveAssignee,
}: ManageAssigneesStepProps) => {
  return (
    <div className="flex flex-col gap-4xl p-3xl">
      <Alert
        variant="info"
        title="Please note"
        description="If you wish to add assignees here, it would apply to all the selected filings. If you want to make specific changes, do it on the filing level."
      />

      <div className="flex flex-col gap-lg">
        <span className="txt-small-bold">Internal assignees</span>

        <Button
          size="sm"
          variant="secondary"
          onClick={onAddAssignees}
          className="w-fit"
        >
          <Icons.Plus className="size-4" />
          <span className="txt-small-medium">Add assignees</span>
        </Button>

        {assignees.length > 0 ? (
          <div className="flex flex-col overflow-clip rounded-md border border-border-primary divide-y divide-border-primary">
            {assignees.map((assignee) => (
              <div
                key={assignee.id}
                className="flex items-center justify-between p-lg hover:bg-bg-secondary transition-colors"
              >
                <div className="flex items-center gap-md">
                  <Avatar size="sm" name={assignee.name} />
                  <div className="flex flex-col">
                    <span className="txt-small-bold">{assignee.name}</span>
                    <span className="txt-small-medium text-text-tertiary">
                      {assignee.email}
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => onRemoveAssignee(assignee)}
                  className="p-1 hover:bg-bg-tertiary rounded-md transition-colors"
                  title="Remove assignee"
                >
                  <Icons.Trash01 className="size-4 text-text-tertiary hover:text-fg-error" />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col gap-lg">
            <span className="txt-small-medium text-text-tertiary">
              No assignees
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
